"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-form-model", _vm._b({
    ref: "form",
    attrs: {
      model: _vm.form,
      layout: "horizontal"
    }
  }, "a-form-model", _vm.layout, false), [_c("a-form-model-item", {
    attrs: {
      label: "类型",
      prop: "type"
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: _vm.operate === "edit"
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "classification"
    }
  }, [_vm._v("科目分类")]), _c("a-radio", {
    attrs: {
      value: "formula"
    }
  }, [_vm._v("自定义公式")])], 1)], 1), _vm.form.type === "classification" ? _c("a-form-model-item", {
    attrs: {
      label: "统计方式",
      prop: "statType"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.statType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "statType", $$v);
      },
      expression: "form.statType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "summary"
    }
  }, [_vm._v("汇总")]), _c("a-radio", {
    attrs: {
      value: "formula"
    }
  }, [_vm._v("自定义公式")])], 1)], 1) : _vm._e(), _c("a-form-model-item", _vm._b({
    attrs: {
      label: "科目名称",
      prop: "name",
      rules: [{
        message: "请输入科目名称",
        required: true,
        trigger: "change"
      }]
    }
  }, "a-form-model-item", _vm.layout, false), [_c("a-input", {
    attrs: {
      "allow-clear": "",
      "max-length": 30,
      placeholder: "请输入科目名称，不超过30个字符"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.name"
    }
  })], 1), _vm.form.type === "formula" || _vm.form.statType === "formula" ? [_c("a-form-model-item", _vm._b({
    attrs: {
      label: "计算公式",
      prop: "formulaRules",
      rules: [{
        message: "请编辑计算公式",
        required: true,
        trigger: "change"
      }]
    }
  }, "a-form-model-item", _vm.layout, false), [_c("FormulaEditor", {
    ref: "formulaEditor",
    attrs: {
      params: {
        dimension: _vm.dimension
      },
      "show-select-formula-entry": _vm.showSelectFormulaEntry,
      "data-source": _vm.dataSource,
      record: _vm.form
    },
    on: {
      change: _vm.handleFormulaEditorChange
    }
  })], 1), _c("a-form-model-item", _vm._b({
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "显示百分比",
      prop: "statType"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("div", [_vm._v("1. 把计算公式得到的结果按百分比显示。如公式得到的结果为“0.25”，则最终显示为“25%”；")]), _c("div", [_vm._v("2. 当显示为百分比时，其值不汇总到上级科目。")])];
      },
      proxy: true
    }], null, false, 1046464388)
  }, "a-form-model-item", _vm.layout, false), [_c("a-radio-group", {
    staticStyle: {
      "margin-left": "4px"
    },
    model: {
      value: _vm.form.percent,
      callback: function ($$v) {
        _vm.$set(_vm.form, "percent", $$v);
      },
      expression: "form.percent"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v("否")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v("是")])], 1)], 1)] : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;